import { render, staticRenderFns } from "./BasketErrorPage.vue?vue&type=template&id=30efcaba"
import script from "./BasketErrorPage.vue?vue&type=script&setup=true&lang=js"
export * from "./BasketErrorPage.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports